export const tableColumnsData: { [key: string]: string } = {
  code: 'Code',
  accountType: 'Account Type',
  name: 'Name',
  description: 'Description',
  more: ''
};
